import { render } from "./SearchClear.vue?vue&type=template&id=40172e1c"
import script from "./SearchClear.vue?vue&type=script&lang=js"
export * from "./SearchClear.vue?vue&type=script&lang=js"
script.render = render

export default script